import { Navigate, RouteObject } from "react-router-dom";
import CadastroInicialView from "./CadastroInicial.View";
import CadastroInicialEmpresaView from "./Empresa/CadastroInicialEmpresa.View";
import CadastroInicialUsuarioView from "./Usuario/CadastroInicialUsuario.View";

export const CadastroInicialRoutes: RouteObject[] = [
  {
    path: "cadastro-inicial",
    element: <CadastroInicialView />,
    children: [
      { index: true, element: <Navigate to="empresa" replace /> },
      { path: "empresa", element: <CadastroInicialEmpresaView /> },
      { path: "usuario", element: <CadastroInicialUsuarioView /> },
    ],
  },
];
